export const useUserSessionLogout = (url = '/users/sessions') => [() => {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = url

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  if (csrfToken) {
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)
  }

  const methodInput = document.createElement('input')
  methodInput.type = 'hidden'
  methodInput.name = '_method'
  methodInput.value = 'delete'
  form.appendChild(methodInput)

  document.body.appendChild(form)
  form.submit()
}]
